import axios from "axios";

axios.defaults.withCredentials = true;

export async function fetchLoggedInUser() {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/customer/`);
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}

export async function fetchLoggedInUserOrders() {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/customer/orders`);
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}

export async function fetchLoggedInUserOrderById(orderId) {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/customer/orders/${orderId}`);
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}

export async function updateUserInfo(change) {
    try {
        const response = await axios.patch(`${process.env.REACT_APP_BACKEND_URL}/customer/`, change);
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}


//Address related

export async function fetchUserAddresses() {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/customer/address`);
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}


export async function addUserNewAddress(address) {
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/address`, address);
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}


export async function deleteUserAddress(addressId) {
    try {
        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/customer/address/${addressId}`);
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}


//wishlist 

export async function addItemInUserWishlist(productId) {
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/wishlist`, { productId });
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}

export async function removeItemFromUserWishlist(wishlistId) {
    try {
        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/customer/wishlist/${wishlistId}`);
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}

export async function fetchItemsInUserWishlist() {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/customer/wishlist`);
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}